package io.archisource.shared

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
enum class PageSourceKindDto {
    XML,
    JSX,
    MARKDOWN,
    HTML,
}

@Serializable
enum class PageContentKindDto {
    UI,
    REST_API,
    JSX,
    HTML,
}

@Serializable
data class PageSummaryDto(
    val path: String,
    val title: String,
    val kind: PageSourceKindDto,
)

@Serializable
data class ContentRevisionDto(
    val revision: Long,
)

@Serializable
data class PageFieldDto(
    val source: String,
    val label: String,
    val metaType: String,
    val baseType: String,
    val nullable: Boolean,
    val renderer: String,
    val editor: String,
    val referencedEntity: String? = null,
    val widgetConfiguration: String? = null,
    val editable: Boolean,
)

@Serializable
data class PageTableDto(
    val source: String,
    val label: String,
    val primaryKeyFields: Set<String>,
    val canCreate: Boolean,
    val canDelete: Boolean,
    val fields: List<PageFieldDto>,
    val controller: String,
)

@Serializable
data class PageQueryDto(
    val id: String,
    val controller: String,
    val columns: List<String>,
    val rows: List<Map<String, JsonElement>>,
)

@Serializable
data class PageContentDto(
    val path: String,
    val title: String,
    val kind: PageContentKindDto,
    val content: String? = null,
    val tables: List<PageTableDto> = emptyList(),
    val queries: List<PageQueryDto> = emptyList(),
)

@Serializable
data class PageRowsDto(
    val path: String,
    val table: String,
    val rows: List<Map<String, JsonElement>>,
)

@Serializable
data class BulkCreateRequestDto(
    val rows: List<Map<String, JsonElement>>,
)

@Serializable
data class RowUpdateDto(
    val key: Map<String, JsonElement>,
    val values: Map<String, JsonElement>,
)

@Serializable
data class BulkUpdateRequestDto(
    val rows: List<RowUpdateDto>,
)

@Serializable
data class BulkDeleteRequestDto(
    val keys: List<Map<String, JsonElement>>,
)

@Serializable
data class MutationResultDto(
    val affectedRows: Int,
)

@Serializable
data class QueryRequestDto(
    val sql: String,
)

@Serializable
data class QueryViewDto(
    val columns: List<String>,
    val rows: List<Map<String, JsonElement>>,
)
